import { Injectable } from '@angular/core';
import {ServiceDocumentPendingApprovalModel} from '../models/service-document-pending-approval-model';
import {firstValueFrom} from 'rxjs';
import {HttpServiceBase} from '../../../core/services/http-service-base';

@Injectable()
export class ServiceHttpService extends HttpServiceBase{


    // https://minntgmbh.atlassian.net/wiki/spaces/BROT/pages/3710812181/GET+Pending+Documents+to+Approve+v1+Changes+21
    async getPendingDocumentsToApprove(): Promise<ServiceDocumentPendingApprovalModel[]> {
        const url = `${this.serverAddress}/v1/brotherDocumentsPendingApproval`;

       const response = await firstValueFrom(
            this.httpClient.get<{ brotherDocuments: ServiceDocumentPendingApprovalModel[] }>(url)
        );
        return response.brotherDocuments;
    }

    // https://minntgmbh.atlassian.net/wiki/spaces/BROT/pages/3710713875/ACCEPT+Conditions+of+Use+Service+Partners+Document+v1+Changes+21
    async acceptCouServicePartnersDocument(userId: number, documentId: number): Promise<void> {
        const url = `${this.serverAddress}/v1/users/${userId}/brotherDocuments/couServicePartners/${documentId}`;

        await firstValueFrom(this.httpClient.post<void>(url, {}));
    }
}
